module.exports = __webpack_public_path__ + "media/images/pin-6d6d452ba038b8eb128baffbd7223ce8.svg";